import React from 'react';
import { blue } from '@mui/material/colors';
import { Delete } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';
import { Charge, ChargeBucketRef } from 'modules/equipment/types';
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { LineItemVisibility } from './LineItemVisibility';
import type { ChargeListingService } from '../../../../../lib';

interface Props {
  charge: Charge;
  rowIndex: number;
  scope: ChargeBucketRef;
  onRemoveRow: VoidFunction;
  chargeService: ChargeListingService;
}

export const InvoiceDescriptionCell = ({ charge, rowIndex, scope, chargeService, onRemoveRow }: Props) => {
  const classes = useStyles();

  if (charge.type === undefined) throw new Error('Charge type is required');

  return (
    <Box className={classes.root}>
      <Box className="content">
        <RenderWithCondition condition={!!charge.isFromCommonRules}>
          <Stack direction="row" gap="0.3rem">
            <Typography variant="caption" className="badge" sx={{ backgroundColor: blue[100] }}>
              Global
            </Typography>
          </Stack>
        </RenderWithCondition>

        <Box className="row">
          <Typography fontWeight="bold">{charge.description || charge.label}</Typography>

          <Stack direction="row" alignItems="center" gap="0.5rem">
            <Tooltip title="Remove row">
              <IconButton className="icon-btn-bordered" color="error" size="small" onClick={onRemoveRow}>
                <Delete fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        </Box>

        <LineItemVisibility rowIndex={rowIndex} scope={scope} chargeService={chargeService} />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    width: '100%',

    '& .content': {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      marginTop: '0.3rem',

      '& .badge': {
        borderRadius: '4px',
        width: 'fit-content',
        padding: '1px 0.25rem',
      },

      '& .row': {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
      },
    },
  },
});
